export class DataSettings {
  public static REGEX = {
    EMAIL: /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/,
    ALPHANUMERIC: /[a-zA-z0-9 ]/,
    NAME: /^[a-zA-Z ]*$/,
    EMAILINPUT: /[a-zA-Z0-9@._]/,
    NUMBERS: /[0-9]/,
    MOBILE: /^(\+91[\-\s]?)?[0]?(91)?[6789]\d{9}$/,
    VALIDMOBILE: /.*(?:(\d)\1{6})/
  };
  public static CONSTANTS: {
    REQUIRED: 'required';
    EMAIL: 'email';
    MOBILE: 'mobile';
  };
}
